import { action } from 'sky-engine/api/index'

import { DELIVERY_PROJECT_REQUIREMENT_MNG } from '@/api/apiModules'

export function getPorjectFeatureDetail(data) {
  return action(DELIVERY_PROJECT_REQUIREMENT_MNG, 'detail', data)
}

export function createProjectRequirementFeature(data) {
  return action(DELIVERY_PROJECT_REQUIREMENT_MNG, 'create', data)
}
